export const FIELDS_TO_REMOVE = [
  'hasSetupFee',
  'setupFee',
  'hasPremiumSupport',
  'premiumSupportFee',
  'selectedPackage'
]

export const directfulServiceNames = {
  CoreServices: 'Directful Core Services',
  PlatformAccessFee: 'Platform access fee',
  Marketing: 'Marketing',
  MarketingWithCommission: 'Marketing with commission',
  Messaging: 'In-property messaging',
  Unlimited: 'Directful unlimited',
  Basic: 'Directful basic',
  DirectfulCore: 'Directful Core',
  Unknown: 'Unknown',
  PaymentCore: 'Payment core',
  ReviewInvite: 'Review invite',
  SetupFee: 'Setup fee',
  PremiumSupport: 'Premium support'
}
